import React from 'react';
import PropTypes from 'prop-types';
import Gallery from './Gallery';
import styles from './styles';

function CoursesGallery({ widget: { options, content } }) {
  return content ? (
    <>
      <Gallery
        content={content}
        options={options}
      />
      <style jsx>{styles}</style>
    </>
  ) : null;
}

CoursesGallery.defaultProps = {
  widget: {
    options: {},
    content: {},
  },
};

CoursesGallery.propTypes = {
  widget: PropTypes.object,
};

export default CoursesGallery;
